import React from "react";
import { observer } from "mobx-react";
import "./ActivityTab.scss";

const ActivityTab = () => <div className="activity-tab">(COMING SOON)</div>;

export default observer(ActivityTab);
